import { Link as RaLink, LinkProps as RaLinkProps } from 'react-admin';

export const Link = RaLink;

export type LinkProps = RaLinkProps;
